import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Grid from '@zenbusiness/zui/Grid';
import Link from '@zenbusiness/zui/Link';
import Paper from '@zenbusiness/zui/Paper';
import { superstyled } from '@zenbusiness/zui/styles';

export const ContactMethodsContainer = superstyled({
  tag: Grid,
  name: 'ContactMethods',
  slot: 'ContactMethodsContainer',
  propsAdded: {
    container: true,
    direction: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    spacing: 1.5,
  },
  styles: ({ theme }) => ({
    gridTemplateColumns: 'repeat(auto-fill, minmax(0, 1fr))',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 24,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  }),
});

export const ContactMethodsGridItem = superstyled({
  tag: Grid,
  name: 'ContactMethods',
  slot: 'ContactMethodsGridItem',
  propsAdded: {
    item: true,
    xs: 12,
    sm: 6,
  },
  styles: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

export const ContactMethodContainer = superstyled({
  tag: Paper,
  name: 'ContactMethods',
  slot: 'ContactMethodContainer',
  propsAdded: {
    variant: 'outlined',
  },
  styles: ({ theme }) => ({
    gap: theme.spacing(2),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    height: '100%',
  }),
});

export const ContactMethodContent = superstyled({
  tag: Box,
  name: 'ContactMethods',
  slot: 'ContactMethodContent',
  styles: ({ theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    gap: theme.spacing(0.5),
  }),
});

export const CTAButton = superstyled({
  tag: Button,
  name: 'ContactMethods',
  slot: 'CTALink',
  propsAdded: {
    color: 'info',
    component: Link,
    variant: 'text',
  },
  styles: {
    paddingLeft: '8px',
    paddingRight: '8px',
  },
});

export const CTAButtonWrapper = superstyled({
  tag: Box,
  name: 'ContactMethods',
  slot: 'CTALinkWrapper',
  styles: {
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'end',
    width: '100%',
  },
});

export const PhoneSupportIcon = superstyled({
  tag: SupportAgentIcon,
  name: 'ContactMethods',
  slot: 'PhoneSupportIcon',
  styles: {
    width: 32,
    height: 32,
  },
});

export const MethodPaper = superstyled({
  tag: Paper,
  name: 'ContactMethods',
  slot: 'MethodPaper',
  styles: ({ theme }) => ({
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
  }),
});
